export default {
      id: "wappen-usage",
      viewBox: "0 0 131 122",
      url: __webpack_public_path__ + "sprite.svg#wappen",
      toString: function () {
        return this.url;
      }
    }